import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Card, CardContent } from "@/components/ui/card";
import { SectionTitle } from "@/components/dashboard/widgets";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { ActionDialog } from "@/components/dashboard/ActionDialog";
import { Copy, Plus } from "lucide-react";
import { copyToClipboard } from "@/lib/clipboard";

export default function Links() {
  const { user } = useAuth();
  const [overview, setOverview] = useState(null);
  const [links, setLinks] = useState([]);
  const [open, setOpen] = useState(false);

  const refresh = () => Promise.all([
    api.get("/affiliate/overview").then(r => setOverview(r.data)),
    api.get("/affiliate/links").then(r => setLinks(r.data)),
  ]);
  useEffect(() => { refresh(); }, []);

  const main = overview?.tracking_link || `https://connex.is/r/${(user?.id || "").slice(0, 8)}`;
  const defaults = [
    { id: "default", name: "Default", url: main, campaign: "Default" },
  ];
  const allLinks = [...defaults, ...links];

  return (
    <div className="space-y-6">
      <SectionTitle title="Tracking links" subtitle="Generate unique links per channel with UTM tagging." actions={<Button className="rounded-full" onClick={() => setOpen(true)} data-testid="aff-new-link"><Plus className="size-4" /> New link</Button>} />

      <ActionDialog
        open={open}
        onOpenChange={setOpen}
        title="Create a tracking link"
        description="Generate a unique link with UTM tagging for any channel."
        endpoint="/affiliate/links"
        submitLabel="Create link"
        testidPrefix="link"
        onSuccess={refresh}
        fields={[
          { name: "name", label: "Link name", required: true, placeholder: "e.g. LinkedIn DM — Mortgage operators", type: "text" },
          { name: "campaign", label: "Campaign", placeholder: "e.g. Mortgage Q1", type: "text" },
          { name: "utm_source", label: "UTM source", placeholder: "linkedin", type: "text" },
          { name: "utm_medium", label: "UTM medium", placeholder: "dm", type: "text" },
        ]}
      />

      <div className="grid gap-4">
        {allLinks.map((l) => (
          <Card key={l.id} className="rounded-xl shadow-soft border-slate-200">
            <CardContent className="p-5 flex items-center gap-3 flex-wrap">
              <div className="flex-1 min-w-[260px]">
                <div className="text-sm font-medium text-slate-900">{l.name}</div>
                <div className="text-xs text-slate-500">Campaign · {l.campaign || "Default"}</div>
                <Input value={l.url} readOnly className="mt-2 font-mono text-xs" />
              </div>
              <Button variant="outline" onClick={() => copyToClipboard(l.url)} className="rounded-full"><Copy className="size-4" /> Copy</Button>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
}
